function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module mention/ui/mentionsview
 */
import ListView from '@ckeditor/ckeditor5-ui/src/list/listview';
import Rect from '@ckeditor/ckeditor5-utils/src/dom/rect';
import '../../theme/mentionui.css';
/**
 * The mention ui view.
 *
 * @extends module:ui/list/listview~ListView
 */

var MentionsView =
/*#__PURE__*/
function (_ListView) {
  _inherits(MentionsView, _ListView);

  /**
   * @inheritDoc
   */
  function MentionsView(locale) {
    var _this;

    _classCallCheck(this, MentionsView);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MentionsView).call(this, locale));

    _this.extendTemplate({
      attributes: {
        class: ['ck-mentions'],
        tabindex: '-1'
      }
    });

    return _this;
  }
  /**
   * {@link #select Selects} the first item.
   */


  _createClass(MentionsView, [{
    key: "selectFirst",
    value: function selectFirst() {
      this.select(0);
    }
    /**
     * Selects next item to the currently {@link #select selected}.
     *
     * If the last item is already selected, it will select the first item.
     */

  }, {
    key: "selectNext",
    value: function selectNext() {
      var item = this.selected;
      var index = this.items.getIndex(item);
      this.select(index + 1);
    }
    /**
     * Selects previous item to the currently {@link #select selected}.
     *
     * If the first item is already selected, it will select the last item.
     */

  }, {
    key: "selectPrevious",
    value: function selectPrevious() {
      var item = this.selected;
      var index = this.items.getIndex(item);
      this.select(index - 1);
    }
    /**
     * Marks item at a given index as selected.
     *
     * Handles selection cycling when passed index is out of bounds:
     * - if the index is lower than 0, it will select the last item,
     * - if the index is higher than the last item index, it will select the first item.
     *
     * @param {Number} index Index of an item to be marked as selected.
     */

  }, {
    key: "select",
    value: function select(index) {
      var indexToGet = 0;

      if (index > 0 && index < this.items.length) {
        indexToGet = index;
      } else if (index < 0) {
        indexToGet = this.items.length - 1;
      }

      var item = this.items.get(indexToGet); // Return early if item is already selected.

      if (this.selected === item) {
        return;
      } // Remove highlight of previously selected item.


      if (this.selected) {
        this.selected.removeHighlight();
      }

      item.highlight();
      this.selected = item; // Scroll the mentions view to the selected element.

      if (!this._isItemVisibleInScrolledArea(item)) {
        this.element.scrollTop = item.element.offsetTop;
      }
    }
    /**
     * Triggers the `execute` event on the {@link #select selected} item.
     */

  }, {
    key: "executeSelected",
    value: function executeSelected() {
      this.selected.fire('execute');
    } // Checks if an item is visible in the scrollable area.
    //
    // The item is considered visible when:
    // - its top boundary is inside the scrollable rect
    // - its bottom boundary is inside the scrollable rect (the whole item must be visible)

  }, {
    key: "_isItemVisibleInScrolledArea",
    value: function _isItemVisibleInScrolledArea(item) {
      return new Rect(this.element).contains(new Rect(item.element));
    }
  }]);

  return MentionsView;
}(ListView);

export { MentionsView as default };